__turbopack_context__.v({
  "container": "Tall-module__ZpkR_q__container",
  "description": "Tall-module__ZpkR_q__description",
  "number": "Tall-module__ZpkR_q__number",
  "slideInRotate": "Tall-module__ZpkR_q__slideInRotate",
  "title": "Tall-module__ZpkR_q__title",
});
